import { render, staticRenderFns } from "./test-tock.vue?vue&type=template&id=7811a452&scoped=true&"
import script from "./test-tock.vue?vue&type=script&lang=js&"
export * from "./test-tock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7811a452",
  null
  
)

export default component.exports